
import React from "react";
import { Schemes } from "../../../../../../utils";
import { i18nManager } from "../../../../../../i18n";
import { Elements } from "../../../../../shared/Elements";
import { Button, Checkbox, Classname, Form } from "@rivtn/noseur";
import { BaseService, IMember, ITournamentEdition, ITournamentEditionWebsite, SanitizedResponse, TournamentService } from "../../../../../../services";
import { Siren } from "../../../../../shared/ConfirmDialog";

export interface TrophiesProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Trophies(props: TrophiesProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.settings.trophies;
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className={Classname.build("profile-settings", "team-settings")}>
        <Checkbox label={labels.enable_ad} defaultChecked={tournamentEditionWebsite?.trophies_settings?.enable_rivtn_ad} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, trophies_settings: { ...tournamentEditionWebsite.trophies_settings, enable_rivtn_ad: e.checked } });
        }} />
        <hr />
        <Checkbox label={labels.enable_cross_filter} defaultChecked={tournamentEditionWebsite?.trophies_settings?.enable_cross_filter} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, trophies_settings: { ...tournamentEditionWebsite.trophies_settings, enable_cross_filter: e.checked } })
        }} />
        <Checkbox label={labels.show_monetary_prize} defaultChecked={tournamentEditionWebsite?.trophies_settings?.show_monetary_prize} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, trophies_settings: { ...tournamentEditionWebsite.trophies_settings, show_monetary_prize: e.checked } })
        }} />
        <Checkbox label={labels.show_physical_prize} defaultChecked={tournamentEditionWebsite?.trophies_settings?.show_physical_prize} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, trophies_settings: { ...tournamentEditionWebsite.trophies_settings, show_physical_prize: e.checked } })
        }} />
        <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
            style={{ marginTop: 20 }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                updateWebsite(() => e.manageRef?.setLoadingState(false));
            }} />
    </Form>);

    function updateWebsite(onDone?: () => void) {
        tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, tournamentEditionWebsite!).then(({ sanitized }: SanitizedResponse<ITournamentEditionWebsite>) => {
            setTournamentEditionWebsite(sanitized);
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Trophies;
